<div
  class="rc-history-panel position-absolute history translate-middle-x start-50 border rounded-2"
>
  <div class="position-relative d-flex align-items-center gap-3 p-3">
    <span
      class="rc-history-close rb-ic rb-ic-close fs-lg position-absolute top-1 end-1 cursor-pointer hover-effect"
      (click)="handleOnHistoryClosed()"
    ></span>
    <ng-container *ngIf="zoomLevelAllowedForHistory()">
      <app-datetime-picker
        [datetime]="currentTimestamp"
        (datetimeChanged)="handleOnTimestampChanged($event)"
        [disabled]="isLoading()"
      >
      </app-datetime-picker>
      <div
        class="rc-history-reload d-flex position-relative align-self-stretch align-items-center btn"
        (click)="handleReloadClick()"
      >
        <span
          class="rc-history-reload-label fs-sm"
          [class.rc-history-reload-label-loading]="isLoading()"
          >Reload</span
        >
        <div class="position-absolute translate-middle start-50 top-50">
          <div
            class="rc-history-spinner spinner-border spinner-border-sm"
            [class.d-none]="!isLoading()"
            role="status"
          ></div>
        </div>
      </div>
      <app-range-picker
        [timespan]="currentTimespan"
        [timestamp]="currentTimestamp"
        (timeSpanToggled)="handleOnTimeSpanChanged($event)"
        [disabled]="isLoading()"
      >
      </app-range-picker>
    </ng-container>

    <ng-container *ngIf="!zoomLevelAllowedForHistory()">
      <div class="d-flex align-items-center gap-1 p-2">
        <span class="rb-ic rb-ic-alert-info text-warning fs-xl"></span>
        <span class="rc-history-hint fs-sm"
          >To get historic data, zoom in to level {{ config.history_min_zoom_level }}</span
        >
      </div>
    </ng-container>
  </div>
</div>
